import React, { useState } from 'react';
import './FloatingWhatsApp.css';
import { FaWhatsapp, FaTimes } from 'react-icons/fa';

const FloatingWhatsApp = () => {
  const [showPopup, setShowPopup] = useState(false);

  const handleClick = () => {
    setShowPopup(!showPopup);  // Toggle the popup display
  };

  const handleSupportClick = () => {
    window.open('https://wa.me/6302536200', '_blank');  // Redirect to WhatsApp
  };

  const closePopup = () => {
    setShowPopup(false);  // Close the popup
  };

  return (
    <>
      <div className="floating-whatsapp" onClick={handleClick}>
        <span className="floating-whatsapp-text">How can I help you?</span>
        <FaWhatsapp size={30} color="white" />
      </div>
      {showPopup && (
        <div className="popup-interface">
          <div className="popup-header">
            <h3>Hello!</h3>
            <FaTimes className="close-popup" onClick={closePopup} />
          </div>
          <div className="popup-content">
            <p>Click one of our contacts below to chat on WhatsApp</p>
            <div className="support-option" onClick={handleSupportClick}>
              <img src={"https://www.gravatar.com/avatar/00000000000000000000000000000000"} alt="Support Icon" />
              <p>Support Team</p>
            </div>
          </div>
          <div className="popup-footer">
            Social Chat is free, download and try it now <a href="https://www.whatsapp.com/download">here!</a>
          </div>
        </div>
      )}
    </>
  );
};

export default FloatingWhatsApp;
